import styled from 'styled-components'
import {maxWidth} from 'resources/react/core/theme'
import {darken} from 'polished'

export const Wrapper = styled.div`
    .header {
        display: flex;
        justify-content: center;
    }

    .accordion__text {
        p {
            margin: 0px;

        }
        a {
            font-size: 20px;
        }
    }    

    .button {
        padding: 10px !important;
        font-size: 13px;
        width: 159px;
        background: #09f;
        color: #fff;
        border: none;
        display: block;
        text-align: center;
        
        p {
            font-size: 13px;
            color: #fff;
            margin: 0px;
        }
    }

    .button-wrap {
        display: flex;
        justify-content: center;
        margin: 30px 0px;
    }

    p {
        color: #333;
        font-size: 16px;
    }

    .section-1 {
        display: flex;
        justify-content: center;
        padding-top: 40px;
        padding-bottom: 80px;

        .text-wrap {
            p {
                margin: 0px;
            }

            a {
                font-size: 20px;
            }            

            h2 {
                margin-top: 0px;
            }

            max-width: 588px;
            padding-left: 25px;
        }
    }

    .section-1-img,
    .section-2-img {
        width: 384px;
        height: 384px;
        background: beige;
    }

    .section-2 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 40px;
        font-family: Lato;
        
        h2 {
            text-align: center;
        }
    } 

    .accordion__content {
        border-bottom: 1px solid #000;
    }

    .accordion-wrap {
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-left: 90px;

        div {
            color: #000;
            width: 1088px;
        }
    }
    
    .section-3 {
        padding: 50px 0px;

        .mobile-slider {
            display: none;
        }

        .text-wrap {

            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;

            h2 {
                margin-top: 0px;
                margin-bottom: 30px;
                text-align: center;
                font-family: Lato;
            }

            .sub-heading {
                display: flex;
                justify-content: center;
                
                span {
                    max-width: 792px;
                    text-align: center;
                }
            }
        }

        .img-wrap {
            display: flex;
            justify-content: space-around;
            padding-top: 25px;

            div {
                display: flex;
                flex-direction: column;
            }
        }
    }

    .section-3-logo {
        width: 275px;
        height: 275px;
        margin: auto;
        margin-bottom: 25px;
    }

    .section-3-logo + p {
        text-align: center;
        font-size: 32px;
        max-width: 384px;
        line-height: 36px;
    }

    h2 {
        p {
            font-size: 39px;
        }
    }

    p {
        font-size: 20px;
        line-height: 1.5;
    }

    h3 {
        margin: 40px 0 15px;
        padding: 0;
    }
    a {
        color: #4a90e2;
        text-decoration: none;
        transition: color 200ms ease;
        font-size: 16px;
        &:hover,
        &:focus {
            color: ${() => darken(.15, '#4a90e2')};
        }
    }

    ${maxWidth.small`
        img {
            height: 100% !important;
        }    

    `}
    ${maxWidth.medium`
        .accordion__text {
            p {
                font-size: 16px;
            }
        }

        .accordion__title {
            font-size: 16px;
        } 

        p {
            font-size: 18px;
            line-height: 1.33;
        }

        .accordion-wrap {

            align-items: center;
            margin-left: 0px;

            div {
                width: 100%;
            }
        }    
        .anchored-nav {
            width: 320px !important;
        }

        .header {
            justify-content: left;
            padding-left: 15px;
            padding-right: 15px;
        }

        .section-1 {
            flex-direction: column;
        }

        .section-1 {
            padding-left: 15px;
            padding-right: 15px;

            .img-wrap {
                display: flex;
                justify-content: center;
            }

            .text-wrap {
                max-width: 100%;
                padding-left: 0px;
                padding-top: 25px;
                line-height: 24px;
            }
        }

        .section-2 {
            padding-left: 15px;
            padding-right: 15px;
            flex-direction: column;
            padding-bottom: 20px;
            background-color: #fff;

            h2 {
                text-align: left;
            }

            .img-wrap {
                display: flex;
                justify-content: center;
            }

            .text-wrap {
                line-height: 24px;
                max-width: 100%;
                padding-top: 25px;
            }
        }

        .section-3 {
            padding-left: 15px;
            padding-right: 15px;
            .mobile-slider {
                display: block;
                padding-top: 20px;

                p {
                    max-width: 100%;
                }
            }
            .img-wrap {
                display: none;
            }
        }
    `}
`
